import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  Input,
  Renderer2,
  TemplateRef,
  ViewContainerRef,
  inject,
  EventEmitter,
  Output,
  OnInit,
  OnDestroy,
  AfterViewInit,
  ViewChild,
} from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'fz-expanded-card',
  templateUrl: './expanded-card.component.html',
  styleUrls: ['./expanded-card.component.scss'],
})
export class ExpandedCardComponent implements OnInit, OnDestroy, AfterViewInit {
  #mode: 'fullscreen' | 'default' = 'default';
  #event: any;

  _ref: ElementRef = inject(ElementRef);
  _render: Renderer2 = inject(Renderer2);
  _containerRef: ViewContainerRef = inject(ViewContainerRef);

  @Input()
  set source(event: any) {
    this.#event = event;
  }

  @Input()
  set mode(mode: 'fullscreen' | 'default') {
    this.#mode = mode;
  }

  get mode() {
    return this.#mode;
  }

  @Input()
  element: any;

  @Input()
  template: TemplateRef<any>;

  @Input()
  tournament: any;

  @Output()
  mouseLeave = new EventEmitter<MouseEvent>();

  @ViewChild('container', { read: ElementRef })
  container: ElementRef;

  ngOnInit() {
    window.addEventListener('scroll', () => {
      this.onMouseLeave();
    });
  }

  ngAfterViewInit() {
    this.showElement();
  }

  ngOnDestroy() {
    window.removeEventListener('scroll', () => {
      this.onMouseLeave();
    });
  }

  hovered = false;
  opened = false;

  showElement() {
    console.group('Show extended card');
    const card = this.#event.target.getBoundingClientRect();
    const ew = 60;
    const dy = card.top - card.height / 2;
    const top = dy > 0 ? dy : 0;
    let _css: Record<string, string | number> = {
      position: 'fixed',
      top: `${top}px`,
      left: `${card.left - ew / 2}px`,
      width: `${card.width + ew}px`,
    };

    if (this.#mode === 'fullscreen') {
      _css = {
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
      };
    }

    // set custom styles like a target
    console.log('Set custom styles like a target');
    Renderer2Utils.addStyles(this._render, this._ref.nativeElement, {
      top: `${card.top}px`,
      left: `${card.left}px`,
      width: `${card.width}px`,
      'min-height': `${card.height}px`,
      opacity: 0,
    });

    // wait for animation
    setTimeout(() => {
      console.log('Wait for animation');

      Renderer2Utils.removeStyles(this._render, this._ref.nativeElement, [
        'opacity',
      ]);
      Renderer2Utils.addStyles(this._render, this._ref.nativeElement, _css);

      // add class to host
      Renderer2Utils.addClass(this._render, this._ref.nativeElement, [
        this.mode,
      ]);

      if (this.mode === 'fullscreen') {
        this.opened = this.mode === 'fullscreen';
      }

      if (this.mode !== 'fullscreen') {
        setTimeout(() => {
          const el = this.container.nativeElement.getBoundingClientRect();
          const dif = window.innerHeight - el.bottom;
          console.log('Dif', dif);
          if (dif < 10) {
            console.log('Fixed top position', dif);

            Renderer2Utils.addStyles(this._render, this._ref.nativeElement, {
              top: `${el.top - Math.abs(dif) - 3}px`,
            });
          }

          console.groupEnd();
        }, 500);
      }
    }, 100);

    this.hovered = true;
  }

  onMouseLeave(event?: MouseEvent) {
    this.mouseLeave.emit(event);
  }
}

class Renderer2Utils {
  static addStyles(
    renderer: Renderer2,
    el: any,
    styles: Record<string, string | number>,
  ) {
    Object.keys(styles).forEach((key) => {
      renderer.setStyle(el, key, styles[key]);
    });
  }
  static removeStyles(renderer: Renderer2, el: any, styles: string[]) {
    styles.forEach((style) => {
      renderer.removeStyle(el, style);
    });
  }

  static addClass(renderer: Renderer2, el: any, classes: string[]) {
    classes.forEach((cls) => {
      renderer.addClass(el, cls);
    });
  }

  static removeClass(renderer: Renderer2, el: any, classes: string[]) {
    classes.forEach((cls) => {
      renderer.removeClass(el, cls);
    });
  }
}
